module.exports = __webpack_public_path__ + "static/media/Husky.f1a00b8e.png";